import { defineStore } from 'pinia';

interface INavbar {
  backgroundColor: string,
  waveColor: string,
  isClub: boolean,
  isHome: boolean,
  isMixitPlus: boolean,
  mixitPlusPrice: string,
  megaMenuId: string,
  megaMenuClassName: string,
}

const defaultValues = {
  backgroundColor: 'bg-secondary',
  waveColor: 'text-primary-200',
  isClub: false,
  isHome: false,
  isMixitPlus: false,
  mixitPlusPrice: '',
  megaMenuId: 'secondary',
  megaMenuClassName: 'lg:block',
}


export const useNavbarStore = defineStore('navbarStore', {
  state: ():INavbar => ({...defaultValues}),

  actions: {
    setNavbar(navbar: Partial<INavbar>) {
      Object.keys(defaultValues).forEach((key) =>{
        // @ts-expect-error key is actually `keyof INavbar`, so this is safe
        this[key] = navbar[key] ?? defaultValues[key]
      })
    },
    setDefault() {
      Object.keys(defaultValues).forEach((key)=>{
        // @ts-expect-error key is actually `keyof INavbar`, so this is safe
        this[key] = defaultValues[key]
      })
    }
  },

  getters: {
    getNavbar: (state) => state,
  },
});
